/**
 * Frontend API configuration.
 *
 * REACT_APP_API_BASE_URL points at the gateway (Traefik). In dev it's
 * http://localhost:8080 (see .env.development). CRA only exposes env vars
 * prefixed with REACT_APP_.
 *
 * Production: build with REACT_APP_API_BASE_URL="" (empty string) for
 * same-origin requests - the web server (Caddy/nginx) reverse-proxies
 * /api/* to the gateway, so no CORS and no hardcoded host.
 */
export const API_BASE =
  process.env.REACT_APP_API_BASE_URL !== undefined
    ? process.env.REACT_APP_API_BASE_URL
    : 'http://localhost:8080';

// localStorage key - kept identical to the legacy value so cross-tab sync and
// any existing sessions keep working.
export const AUTH_STORAGE_KEY = 'farmgate-auth';
